module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tabs', {
    attrs: {
      "fixed": "",
      "centered": ""
    }
  }, [_c('v-tabs-bar', {
    staticClass: "blue lighten-1",
    attrs: {
      "dark": ""
    }
  }, [_c('v-tabs-slider', {
    staticClass: "yellow"
  }), _vm._v(" "), _vm._l((_vm.items), function(item, i) {
    return _c('v-tabs-item', {
      key: i,
      attrs: {
        "href": '#tab-' + i
      }
    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")])
  })], 2), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab-0"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Ihre Zugangsdaten zum Online-Portal")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Benutzername"
    },
    model: {
      value: (_vm.account.username),
      callback: function($$v) {
        _vm.$set(_vm.account, "username", $$v)
      },
      expression: "account.username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "E-Mail-Adresse"
    },
    model: {
      value: (_vm.account.email),
      callback: function($$v) {
        _vm.$set(_vm.account, "email", $$v)
      },
      expression: "account.email"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Passwort ändern"
    },
    model: {
      value: (_vm.account.changepwd),
      callback: function($$v) {
        _vm.$set(_vm.account, "changepwd", $$v)
      },
      expression: "account.changepwd"
    }
  }), _vm._v(" "), (_vm.account.changepwd) ? _c('v-text-field', {
    attrs: {
      "label": "Passwort",
      "append-icon": _vm.e1 ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.e1 = !_vm.e1); },
      "type": _vm.e1 ? 'password' : 'text',
      "required": ""
    },
    model: {
      value: (_vm.account.password),
      callback: function($$v) {
        _vm.$set(_vm.account, "password", $$v)
      },
      expression: "account.password"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": _vm.updateAccount
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "tab-1"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Kundendaten bearbeiten")]), _vm._v(" "), _c('v-card-text')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49db3ec6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountOverview.vue
// module id = 585
// module chunks = 1